export default __webpack_public_path__ + "static/media/pop_logo_ja-JP.f45b193b.png";